import React from "react";

import { IconeAlerta, IconeCapsLock, IconeCheck } from "./icones";

/** Erro inline (.f-msg.err) — sempre role="alert" para o leitor de tela. */
export function MensagemErro({ id, className = "", children }) {
  return (
    <p id={id} className={`f-msg err ${className}`.trim()} role="alert">
      <IconeAlerta />
      <span>{children}</span>
    </p>
  );
}

/** Confirmação inline (.f-msg.ok), ex.: "As senhas conferem.". */
export function MensagemSucesso({ id, children }) {
  return (
    <p id={id} className="f-msg ok">
      <IconeCheck tamanho={14} />
      <span>{children}</span>
    </p>
  );
}

/** Aviso inline (.f-msg.warn), anunciado sem interromper. */
export function MensagemAviso({ id, icone = "alerta", children }) {
  return (
    <p id={id} className="f-msg warn" role="status">
      {icone === "caps" ? <IconeCapsLock /> : <IconeAlerta />}
      <span>{children}</span>
    </p>
  );
}
